import React from "react";
import { SimpleShowLayout, TextField } from "react-admin";

const Tab = (props) => {
  return (
    <SimpleShowLayout {...props}>
      <TextField source="football.id" />
      <TextField source="football.seasonWins" />
      <TextField source="football.seasonLosses" />
      <TextField source="football.seasonTies" />
      <TextField source="football.seasonPercentWins" />
      <TextField source="football.districtWins" />
      <TextField source="football.districtLosses" />
      <TextField source="football.districtTies" />
      <TextField source="football.districtPercentWins" />
      <TextField source="football.homeWins" />
      <TextField source="football.homeLosses" />
      <TextField source="football.homeTies" />
      <TextField source="football.roadWins" />
      <TextField source="football.roadLosses" />
      <TextField source="football.roadTies" />
      <TextField source="football.streak" />
      <TextField source="football.differential" />

      <TextField source="football.pointsFor" />
      <TextField source="football.pointsForPerGame" />
      <TextField source="football.totalYards" />
      <TextField source="football.totalYardsPerGame" />
      <TextField source="football.rushingYards" />
      <TextField source="football.rushingYardsPerGame" />
      <TextField source="football.passingYards" />
      <TextField source="football.passingYardsPerGame" />

      <TextField source="football.pointsAgainst" />
      <TextField source="football.pointsAgainstPerGame" />
      <TextField source="football.totalYardsAllowed" />
      <TextField source="football.totalYardsAllowedPerGame" />
      <TextField source="football.rushingYardsAllowed" />
      <TextField source="football.rushingYardsAllowedPerGame" />
      <TextField source="football.passingYardsAllowed" />
      <TextField source="football.passingYardsAllowedPerGame" />
    </SimpleShowLayout>
  );
};

export default Tab;
